export default "__VITE_ASSET__BGP1ZnSx__"